import { IProductDefinition } from '@ads/front-core/products/IProductDefinition'
import { Eye } from '@ads/front-core/Icons/wizard'
import { lng } from '@ads/front-core/locales'
import limits from '@ads/front-core/constants/limits'
import { ProductFor, WizardSubCategoryEnum } from '@ads/front-core/interfaces'
import { campaignMaxDateByDays } from './utils'

export const UNIVERSAL_CPM: IProductDefinition = {
  productTypeId: 'UNIVERSAL_CPM',
  productAvailableFor: [ProductFor.NONPUBLISHER],
  createUrl: '/campaign/create/universal-cpm/',
  title: 'campaign:displayCPM.displayCPM',
  budget: {
    model: 'CPM',
    type: 'TOTAL',
    variant: 'ANY',
    validation: {
      globalLimit: {
        min: limits.MINIMUM_BUDGET,
      },
      dailyLimit: {
        min: limits.MINIMUM_DAILY_BUDGET,
      },
      rate: {
        min: 0.3,
        max: limits.MAXIMUM_RATE_CPM,
      },
    },
  },
  campaignHowToWorks: 'campaign:displayCPM.howDisplayCPMWorks',
  campaignMinimumRates: {
    fields: ['DEFAULT'],
    inputType: 'currency',
  },
  campaignMaxDate: campaignMaxDateByDays(90),
  capping: true,
  allowedCreationTypes: ['BANNER', 'HTML', 'CODE', 'RICH_MEDIA'],
  creationsDescription: {
    description: 'campaign:displayCPC.addMoreCreationsDescription',
  },
  targeting: {
    countries: true,
    devices: true,
    demography: true,
    emitToTrusted: true,
    locations: true,
    segmentsTab: ['segments', 'retargetingSegments'],
  },
  wizard: {
    subCategory: WizardSubCategoryEnum.DISPLAY_CPM,
    productDescription: {
      title: lng('campaign:views'),
      description: lng('wizard:displayCPMDescription'),
      Icon: Eye,
    },
    parameters: [
      {
        label: lng('campaign:format'),
        value: lng('campaign:banner'),
      },
      {
        label: lng('campaign:billingModel'),
        value: lng('wizard:budgetModel.cpm'),
      },
      {
        label: lng('wizard:destination'),
        value: lng('wizard:buildingAwarenessReach'),
      },
    ],
  },
}
